<div class="cb-layout-col" [class.cb-scrollable]="scrollable()" [style.align-items]="alignStyle()"
    [style.justify-content]="justifyStyle()">
    <ng-content></ng-content>
</div>